import api from '../api/offlineClient';

function resizeToJpeg(file, maxSize) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = e => {
      const img = new Image();
      img.onload = () => {
        let w = img.width, h = img.height;
        if (w > h) { if (w > maxSize) { h = Math.round(h * maxSize / w); w = maxSize; } }
        else if (h > maxSize) { w = Math.round(w * maxSize / h); h = maxSize; }
        const canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        canvas.toBlob(b => b ? resolve(b) : reject(new Error('No se pudo procesar la imagen')), 'image/jpeg', 0.85);
      };
      img.onerror = reject;
      img.src = e.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

// Sube una foto de avatar directamente a Cloudinary (browser → Cloudinary) usando
// la firma que da el backend, igual que el flujo ya existente en Endesa.
export async function uploadAvatar(file) {
  const blob = await resizeToJpeg(file, 400);
  const sign = await api.get('/api/auth/sign-upload');
  const { timestamp, folder, signature, api_key, cloud_name } = sign;
  const fd = new FormData();
  fd.append('file', blob, 'avatar.jpg');
  fd.append('api_key', api_key);
  fd.append('timestamp', String(timestamp));
  fd.append('signature', signature);
  fd.append('folder', folder);
  const res = await fetch(`https://api.cloudinary.com/v1_1/${cloud_name}/image/upload`, { method: 'POST', body: fd });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error?.message || 'Error subiendo la imagen');
  return { foto_url: data.secure_url, foto_public_id: data.public_id };
}
